import React from 'react';
import sharedAction from 'shared/routes/firms/firm';
import Layout from 'desktop/components/Layout';
import Firm from './Firm';

async function action(params) {
  const data = await sharedAction(params);

  if (!data) {
    return null;
  }

  const {
    queryParams,
    title,
    description,
    firmInfo,
    tab,
    news,
    newsPage,
    query,
    url,
    transportType,
  } = data;

  return {
    chunks: ['firm'],
    title,
    description,
    component: (
      <Layout currentRoute={url} hideLocations>
        <Firm
          queryParams={queryParams}
          firmInfo={firmInfo}
          tab={tab}
          news={news}
          newsPage={newsPage}
          query={query}
          url={url}
          transportType={transportType}
        />
      </Layout>
    ),
  };
}

export default action;



// WEBPACK FOOTER //
// ./src/desktop/routes/service/car-drive/firm/index.js